<template>
  <textarea
    :style="computedStyles"
    v-model="val"
    @focus="resize"
  ></textarea>
</template>
<script>
// Local Vue 3 port of vue-textarea-autosize 1.1.1 (verbatim logic).
// Native Vue 3 v-model contract (modelValue/update:modelValue).
export default {
  name: 'TextareaAutosize',
  props: {
    modelValue: { type: [String, Number], default: '' },
    // Legacy vue-textarea-autosize (Vue 2) API: callers bind `:value` and
    // listen to the native `blur`. Declaring `value` as a prop keeps it from
    // falling through onto the <textarea>, where Vue 3 would re-patch it on
    // every re-render and wipe what the user just typed.
    value: { type: [String, Number], default: null },
    autosize: { type: Boolean, default: true },
    minHeight: { type: [Number], default: null },
    maxHeight: { type: [Number], default: null },
    important: { type: [Boolean, Array], default: false },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      val: null,
      maxHeightScroll: false,
      height: 'auto',
    };
  },
  computed: {
    computedStyles() {
      if (!this.autosize) return {};
      return {
        resize: !this.isResizeImportant ? 'none' : 'none !important',
        height: this.height,
        overflow: this.maxHeightScroll ? 'auto' : (!this.isOverflowImportant ? 'hidden' : 'hidden !important'),
      };
    },
    isResizeImportant() {
      const imp = this.important;
      return imp === true || (Array.isArray(imp) && imp.includes('resize'));
    },
    isOverflowImportant() {
      const imp = this.important;
      return imp === true || (Array.isArray(imp) && imp.includes('overflow'));
    },
    isHeightImportant() {
      const imp = this.important;
      return imp === true || (Array.isArray(imp) && imp.includes('height'));
    },
  },
  watch: {
    modelValue(val) {
      this.val = val;
    },
    value(val) {
      this.val = val;
    },
    val(val) {
      this.$nextTick(this.resize);
      this.$emit('update:modelValue', val);
    },
    minHeight() {
      this.$nextTick(this.resize);
    },
    maxHeight() {
      this.$nextTick(this.resize);
    },
    autosize(val) {
      if (val) this.resize();
    },
  },
  methods: {
    resize() {
      const important = this.isHeightImportant ? 'important' : '';
      this.height = `auto${important ? ' !important' : ''}`;
      this.$nextTick(() => {
        let contentHeight = this.$el.scrollHeight + 1;
        if (this.minHeight) {
          contentHeight = contentHeight < this.minHeight ? this.minHeight : contentHeight;
        }
        if (this.maxHeight) {
          if (contentHeight > this.maxHeight) {
            contentHeight = this.maxHeight;
            this.maxHeightScroll = true;
          } else {
            this.maxHeightScroll = false;
          }
        }
        const heightVal = contentHeight + 'px';
        this.height = `${heightVal}${important ? ' !important' : ''}`;
      });
      return this;
    },
  },
  created() {
    this.val = this.value !== null ? this.value : this.modelValue;
  },
  mounted() {
    this.resize();
  },
};
</script>
